import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {Icon} from "@vds/icons";
// import ReactModal from "react-modal";
import { Modal as ReactModal } from "@vds/modals";
import { connect } from "react-redux";

import { handleModalState } from "./actions/handleModalState";
import { sendCustomEvent } from "utils/taggingUtils";

import "./Modal.css";

// if (process.env.NODE_ENV !== 'test') ReactModal.setAppElement("#root");

class Modal extends Component {
  state = {
    hasVzdl: false
  };

  componentDidMount() {
    if (window.vzdl && window.vzdl.page) {
      setTimeout(() => {
        const el = document.querySelector(".Modal h2");
        if (el) {
          window.vzdl.page.detail = el.textContent;
          sendCustomEvent("pageViewUpdate");
        }
      }, 1);
      this.setState({ hasVzdl: true });
    }
  }

  componentWillUnmount() {
    this.props.handleModalState(false);

    if (this.state.hasVzdl) {
      window.vzdl.page.detail = "";
      sendCustomEvent("pageViewUpdate");
    }
  }

  render() {
    return (
      <ReactModal
        id={this.props.id?this.props.id:""}
        aria-label={this.props.contentLabel}
        hideCloseButton={false} 
        disableOutsideClick={true}
        enableBackButton={false}
        opened={
          this.props.showModal ||
          this.props.showTimeoutModal ||
          this.props.showCancelModal ||
          this.props.visibleModal
        }
        onOpenedChange={(opened) =>{
          if(!opened){
            this.props.closeModal ?
            this.props.closeModal() : this.props.handleModalState(false)
          }
        }}
      >
        {/* {!this.props.hideCloseButton ? (
          <CloseButton
            aria-label="close modal"
            onClick={
              this.props.closeModal ? () => this.props.closeModal() : () => this.props.handleModalState(false)
            }
          >
            <Icon name="close" focusable="false" style={{ fontSize: "36px" }} />
          </CloseButton>
        ) : null} */}
        {this.props.children}
      </ReactModal>
    );
  }
}

const mapStateToProps = ({ modalState }) => ({
  showModal: modalState.showModal
});

Modal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  contentLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  handleModalState: PropTypes.func,
  hideCloseButton: PropTypes.bool,
  closeModal: PropTypes.func
};

export default connect(
  mapStateToProps,
  { handleModalState }
)(Modal);

const CloseButton = styled.button`
  position: absolute;
  top: 3px;
  right: 3px;
  border: none;
  background: none;
  z-index: 99;
  cursor: pointer;
  padding: 0;
`;
